import CompanyTypes from "./actionTypes"

const INIT_STATE = {
  company: {
    loading: true,
    data: {}
  },
  postCompany: {
    loading: false
  },
  detail: {
    loading: false,
    data: {}
  },
  list: {
    loading: true,
    data: []
  }
}

const Company = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CompanyTypes.GET_COMPANY_PAGES_SUCCESS:
      return {
        ...state,
        company: action.payload,
      }
    case CompanyTypes.GET_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      }

    case CompanyTypes.POST_COMPANY_SUCCESS:
      return {
        ...state,
        postCompany: action.payload
      }
    case CompanyTypes.GET_DETAIL_COMPANY_BY_ID_SUCCESS:
      return {
        ...state,
        detail: action.payload
      }
    case CompanyTypes.PUT_COMPANY_SUCCESS:
      return {
        ...state,
        detail: action.payload
      }

    default:
      return state
  }
}

export default Company
